import { render, staticRenderFns } from "./WebLinkSidebar.vue?vue&type=template&id=15b87db5&scoped=true&"
import script from "./WebLinkSidebar.vue?vue&type=script&lang=js&"
export * from "./WebLinkSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WebLinkSidebar.vue?vue&type=style&index=0&id=15b87db5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b87db5",
  null
  
)

export default component.exports